import { lazy } from 'react';

// project imports
import Loadable from 'components/ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

// login routing
const Login = Loadable(lazy(() => import('views/signin/signin-pages')));

// 404 routing
const ErrorFourNotFour = Loadable(lazy(() => import('components/ui-component/FourNotFour')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
	path: '/',
	element: <MinimalLayout />,
	children: [
		{
			path: '/signin',
			element: <Login />,
		},
		{
			path: '*',
			element: <ErrorFourNotFour />,
		},
	],
};

export default AuthenticationRoutes;
